import AppData from "../data/AppData";
import User from "../data/User";
import HashUtil from "../util/HashUtil";
import XMLUtil from "../util/XMLUtil";
import { ApiAccess } from "./ApiAccess";
import { ApiErrors, IError } from "./ApiErrors";
import ApiGoogleMaps from "./ApiGoogleMaps";
import  ApiCDR from "./ApiCDR";
import { dispatch } from "../dispatcher/Dispatcher";
import AppEvent from "../events/AppEvent";

export type ApiCallback = ($success:boolean, $results:any)=>void;



interface IConfigData{
    label:string;
    value:string;
    default?:boolean;
}

class ApiData{
    access:ApiAccess = new ApiAccess();
    googleMap:ApiGoogleMaps = new ApiGoogleMaps();
    
	strKey:string = 						"oicuv0s9df8gqv5uc480n09c8nq09wmf43089";
    strSecret:string = 					    "dfaf908sdaf09suzpoqwd908fsad09fic9ds08gwirjeiofjc90";
    
    strEvnURL:string = "";//set by config.xml
    strEnvName:string = "";//set by config.xml

    strPSAPEvnURL:string = "";//set by config.xml
    strPSAPEnvName:string = "";//set by config.xml

    strOrg:string = "";//set by config.xml
    strOrgName:string = ""//set by config.xml

    arrOrgs:IConfigData[] = [];
    arrEnvironments:IConfigData[] = [];
    arrPSAPEnvironments:IConfigData[] = [];
    arrCallHistoryEnvs:IConfigData[] = [];

    cdr:ApiCDR = new ApiCDR();

    strCallHistoryEnvTime:string = "";//set by config.xml
    strCallHistoryEnvName:string = "";//set by config.xml

    createAuthBlock(){
        
        const numMSNow:number = Date.now();        
        const strUniqueID:string = User.deviceID;        
        const strSequenceNumber:string = HashUtil.sha1(strUniqueID);
        const txt:string = strSequenceNumber+(numMSNow%10000);
        const strValidation:string = HashUtil.md5(txt);

        const objAuth:any = {};
        objAuth.apikey = this.strKey;
        objAuth.apisecret = this.strSecret;
        objAuth.validation = strValidation;
        objAuth.timestamp = ""+numMSNow;
        objAuth.sequenceNum = strSequenceNumber;

        return objAuth;
    }

    async loadConfig($complete:ApiCallback){
        let success:boolean=false;

        try{
            let strURL:string = "config.xml";

            const rawResult = await this.fetchAsyncText(strURL,"GET");
            const result = XMLUtil.parseStringXMLToObj(rawResult);
            

            if(result && result.data){
                let envOk:boolean=false;
                let envPSAPOk:boolean=false;


                const findDefault = ($data:IConfigData[])=>{

                    let strName:string = "";
                    let strDefault:string = "";
                    let len:number = $data.length;
                    //find first instance of default
                    for(let i:number=0; i<len; i++){
                        if($data[i].default){
                            strDefault = $data[i].value;
                            strName = $data[i].label;
                            $data[i].label = $data[i].label+" (Default)";
                            break;
                        }
                    }
                    //if nothing, do first
                    if(strDefault===""){
                        strDefault = $data[0].value;
                        strName = $data[0].label;
                        $data[0].label = $data[0].label+" (Default)";
                    }

                    return {theDefault:strDefault, name:strName};

                }

                if(result.data.envs && result.data.envs.env && result.data.envs.env.length && result.data.envs.env.length!==0){
                    this.arrEnvironments = result.data.envs.env;
                    envOk=true;
                    
                    const {theDefault, name} = findDefault(this.arrEnvironments);
                    this.strEvnURL = theDefault;
                    this.strEnvName = name;

                }

                if(result.data.psapEnvs && result.data.psapEnvs.env && result.data.psapEnvs.env.length && result.data.psapEnvs.env.length!==0){
                    this.arrPSAPEnvironments = result.data.psapEnvs.env;
                    envPSAPOk=true;
                    
                    const {theDefault, name} = findDefault(this.arrPSAPEnvironments);
                    this.strPSAPEvnURL = theDefault;
                    this.strPSAPEnvName = name;

                }

                if(result.data.callHistoryEnvs && result.data.callHistoryEnvs.env && result.data.callHistoryEnvs.env.length && result.data.callHistoryEnvs.env.length!==0){

                    this.arrCallHistoryEnvs = result.data.callHistoryEnvs.env;
                    

                    const {theDefault, name} = findDefault(this.arrCallHistoryEnvs);
                    this.strCallHistoryEnvTime = theDefault;
                    this.strCallHistoryEnvName = name;

                }


                if(envOk && envPSAPOk){
                    success=true;
                }


            }


        }catch($error){
            
        }
        $complete(success,{});

    }

    async fetchAsyncText($url:string,$method:string="POST",$data:any=null){
        let strPayload:string = "";
        if($data){
            strPayload = $data;
        }        
        let reqInit:RequestInit = {
            method:$method
        };
        if(strPayload!==""){
            reqInit.body = strPayload;
        }

        
        let canShowDebug = AppData.debugMode;

        if(canShowDebug) console.log(">>>"+$url);        
        try{
            const response:Response = await fetch($url,reqInit);
            const text:any = await response.text();     
            if(canShowDebug) console.log("<<<"+$url+" resp: ", text);          
            return text;
        }catch($error){
            if(canShowDebug) console.log("<<<ERROR:",$error);            
            return Promise.reject(new Error("Error loading: "+$url));
        }
    } 

    async fetchAsyncJSON($url:string, $method:string="POST", $data:any, $options?:{isLogout?:boolean}){

        let strPayload:string = JSON.stringify($data);
        

        let reqInit:RequestInit = {
            method:$method,
           /*headers:{
                "accept-language":"data="+(strPayload.length),
                'content-type': 'application/x-www-form-urlencoded'
            },
            */
            //headers:headers,
        };
        reqInit.body = strPayload;
        
        let canShowDebug = AppData.debugMode;

        if(canShowDebug) console.log(">>>"+$url+" requ: ",strPayload);      

        try{

            let strUrl = $url;

            const response:Response = await fetch(strUrl,reqInit);
            
            let apiError:IError | undefined = undefined;;

            //HTTP STATUS CODES
            switch(response.status){
                case 404:
                    //loading error
                    apiError = ApiErrors.LOADING;
                break;
                case 503:
                    //system error
                    apiError = ApiErrors.SYSTEM;
                break;
            }


            if(!apiError){//ok
                const json:any = await response.json();

                let forceLogoutApiError;

                let alertsAvailable:boolean=false;


                //SUMMARY STATUS CODES
                if(json && json.summary){
                    if(json.summary.alertsAvailable){
                        alertsAvailable = true;
                    }
                    if(json.summary.code){
                        let errorFromCode = ApiErrors.findErrorWithCode(json.summary.code,ApiErrors.FORCE_LOGOUT_ERROR_CODES);

                        if(errorFromCode){
                            forceLogoutApiError = errorFromCode;
                        }
                    }

                }

                let isThisApiCallTheLogoutMethod:boolean=false;
                if($options && $options.isLogout){
                    isThisApiCallTheLogoutMethod=true;
                }
                
                //we don't want to activate a force_logout if the person is trying to already logout
                if(forceLogoutApiError && !isThisApiCallTheLogoutMethod){
                    dispatch(AppEvent.FORCE_LOGOUT);
                }

                if(canShowDebug) console.log("<<<"+$url+" resp: ",json);               
                return json;
            }else{//error
                return Promise.reject(apiError);
            }

        }catch($error:any){
            if(canShowDebug) console.log("<<<ERROR:"+$url,$error);            
            return Promise.reject($error+"");
        }
    }



}



const Api:ApiData = new ApiData();
export default Api;